import { Link } from 'react-router-dom';
import PrivacyAssurance from './PrivacyAssurance';

const Footer = () => {
  return <footer className="bg-dark-bg text-white">
      <div className="container mx-auto px-4 py-[50px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="block mb-4">
              <img src="/images/forti-fi-logo-full-white.png" alt="Forti-Fi" onError={e => {
              console.error("Footer logo failed to load");
              const img = e.target as HTMLImageElement;
              img.alt = "Forti-Fi";
              img.src = "";
              img.style.display = "none";
              // Create and insert text fallback
              const textFallback = document.createElement('span');
              textFallback.textContent = "Forti-Fi";
              textFallback.className = "font-serif text-gold text-xl font-bold";
              img.parentNode?.appendChild(textFallback);
            }} className="h-auto w-56 object-contain" />
            </Link>
            <p className="text-white/70 mb-6 max-w-md">
              Advanced perimeter security solutions designed for discerning property owners who value both protection and discretion.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-gold font-serif mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/70 hover:text-gold transition-colors highlight-underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-gold transition-colors highlight-underline">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-white/70 hover:text-gold transition-colors highlight-underline">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-gold transition-colors highlight-underline">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-gold transition-colors highlight-underline">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-gold font-serif mb-4">Contact Us</h3>
            <address className="not-italic text-white/70">
              <p className="mb-2">Ontario, Canada</p>
              <p className="mb-2">
                <a href="mailto:info@forti-fi.ca" className="hover:text-gold transition-colors highlight-underline">
                  info@forti-fi.ca
                </a>
              </p>
              <p>
                <a href="tel:+1234567890" className="hover:text-gold transition-colors highlight-underline">
                  (XXX) XXX-XXXX
                </a>
              </p>
            </address>
          </div>
        </div>
        
        {/* Privacy Assurance */}
        <PrivacyAssurance />
        
        {/* Copyright */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/50 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Forti-Fi. All rights reserved.
          </p>
          <div className="flex space-x-4">
            <Link to="/privacy" className="text-white/50 text-sm hover:text-gold transition-colors highlight-underline">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/50 text-sm hover:text-gold transition-colors highlight-underline">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
